<div *ngIf="(visitor$ | async) as visitor; else loading"
     class="visitor-info"
     [attr.data-automation-id]="'bc-detailed-visitor-info'">
  <div class="bc-panel-header">
    <svg-icon icon="info-outline" class="bc-panel-header-icon"></svg-icon>
    <span class="bc-panel-header-text">{{ 'bcVisitorInfo.visitorInfo' | translate }}</span>
  </div>

  <div class="bc-panel-body">
    <app-visitor-info-field-block *ngFor="let visitorInfoFieldBlock of getDetailedDataObjectKeys(visitor.detailedData); trackBy: trackByObjectKey"
                                  [visitorInfoFieldBlock]="visitor.detailedData[visitorInfoFieldBlock]"
                                  [isNotAvailableDataHidden]="isNotAvailableDataHidden"
                                  [title]="'bcVisitorInfo.' + visitorInfoFieldBlock"
                                  [isBlockOpen]="blockDefaultOpenStates[visitorInfoFieldBlock]"
                                  (blockStateToggled)="blockStateToggled(visitorInfoFieldBlock, $event)">
    </app-visitor-info-field-block>
    <app-auto-save [model]="blockDefaultOpenStates" [storageKey]="'detailed-data-open-states'"></app-auto-save>
  </div>
</div>
<ng-template #loading>
  <app-loading></app-loading>
</ng-template>
